<template>
  <li class="search-results-list-item">
    <h3
      v-if="item.Title"
      :class="[item.Description ? 'mb-2' : 'mb-0']"
    >
      <a :href="item.Path">{{ item.Title }}</a>
    </h3>
    <!-- eslint-disable-next-line -->
    <p v-if="item.Description" v-html="item.Description"></p>
  </li>
</template>

<script>
export default {
  name: 'KfSearchResultsItem',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
